import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';
import { View, XStack, YStack } from 'tamagui';

import PSBox from '@/components/ui/PSBox';
import PSIcon from '@/components/ui/PSIcon';
import PSText from '@/components/ui/PSText';
import { color, radius } from '@/constants/tokens';
import { EVENT_VARIANTS } from '@/src/lib/eventFixtures';

export default function PSBookedBanner({
  title,
  subtitle,
  ctaTitle,
  onPress,
  variant,
}: {
  title: string;
  subtitle: string;
  ctaTitle: string;
  onPress: () => void;
  variant?: 'default' | 'gray';
}) {
  return (
    <PSBox
      alignSelf="stretch"
      borderColor="$color.transparent"
      overflow="hidden"
      cursor="pointer"
      backgroundColor={
        variant === 'gray' ? '$color.backgroundSecondary' : '$color.transparent'
      }
      pressStyle={{ opacity: 0.6 }}
      onPress={onPress}
    >
      {variant !== 'gray' && (
        <LinearGradient
          colors={[color.brand, color.textWhite]}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 1, y: 0.5 }}
          style={{
            ...StyleSheet.absoluteFill,
            opacity: 0.2,
            // border radius here because linear gradient is eclipses the border
            // radius of surrounding box
            borderRadius: radius.base,
          }}
        />
      )}

      <XStack items="center" justify="space-between" gap="$space.md">
        <YStack flexShrink={1} gap={'$space.xs'}>
          <PSText.H1 color="$textDark">{title}</PSText.H1>
          <PSText.Body3 color="$textDarkMuted">{subtitle}</PSText.Body3>
        </YStack>

        <XStack items="center" gap="$space.sm" flexShrink={0}>
          <PSText.Body2 color="$brand">{ctaTitle}</PSText.Body2>
          <PSIcon name="arrow-forward" color="$brand" size={20} />
        </XStack>
      </XStack>
    </PSBox>
  );
}
